module.exports = __webpack_public_path__ + "img/logo1.ee33f8a2.png";